var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { EColumnKind, EPendingReason, EWidgetFailure, EWidgetRenderState, POSITION_COLUMN, } from "./types";
import { MonitoringDataTable } from "./MonitoringDataTable";
import { MonitoringKpi } from "./MonitoringKpi";
var WORDS = (_a = {},
    _a[EWidgetRenderState.NOT_CONNECTED] = {
        title: "monitoring.unavailable.notConnected",
        help: "monitoring.unavailable.notConnectedHelp",
    },
    _a[EWidgetRenderState.NO_SNAPSHOT] = {
        title: "monitoring.unavailable.noSnapshot",
        help: "monitoring.unavailable.noSnapshotHelp",
    },
    _a[EWidgetRenderState.SCOPE_PENDING] = {
        title: "monitoring.unavailable.scopePending",
        help: "monitoring.unavailable.scopePendingHelp",
    },
    _a[EWidgetRenderState.RENDER_FAILED] = {
        title: "monitoring.unavailable.renderFailed",
        help: "monitoring.unavailable.renderFailedHelp",
    },
    _a[EWidgetRenderState.INVALID] = {
        title: "monitoring.unavailable.invalid",
        help: "monitoring.unavailable.invalidHelp",
    },
    _a[EWidgetFailure.REQUEST_FAILED] = {
        title: "monitoring.unavailable.requestFailed",
        help: "monitoring.unavailable.requestFailedHelp",
    },
    _a);
/** Counting again with newly saved settings: pending, but not for the selection. */
var SETTINGS_PENDING_WORDS = {
    title: "monitoring.unavailable.settingsPending",
    help: "monitoring.unavailable.settingsPendingHelp",
};
/** A table of one row reads better as figures. */
function Fallback(_a) {
    var table = _a.table, title = _a.title;
    var figures = table.columns
        .map(function (column, index) { var _a; return ({ column: column, value: (_a = table.rows[0]) === null || _a === void 0 ? void 0 : _a[index] }); })
        .filter(function (_a) {
        var column = _a.column;
        return column.name !== POSITION_COLUMN && column.kind !== EColumnKind.TEXT;
    });
    if (table.rows.length === 1 && figures.length) {
        return (_jsx(Stack, { direction: "row", flexWrap: "wrap", useFlexGap: true, spacing: 2, children: figures.map(function (_a) {
                var column = _a.column, value = _a.value;
                return (_jsx(MonitoringKpi, { label: column.name, value: value, kind: column.kind }, column.name));
            }) }));
    }
    return _jsx(MonitoringDataTable, { table: table, caption: title });
}
/** Why a widget shows no chart: never a zero standing in for a figure nobody counted. */
export function MonitoringWidgetUnavailable(_a) {
    var state = _a.state, reason = _a.reason, problem = _a.problem, _b = _a.diagnostics, diagnostics = _b === void 0 ? [] : _b, table = _a.table, title = _a.title;
    var t = useTranslation().t;
    var words = state === EWidgetRenderState.SCOPE_PENDING && reason === EPendingReason.SETTINGS_PENDING
        ? SETTINGS_PENDING_WORDS
        : WORDS[state];
    var reasonText = reason ? t("monitoring.reasons.".concat(reason), { defaultValue: reason }) : "";
    var errors = diagnostics.map(function (diagnostic) { return diagnostic.message; });
    return (_jsxs(Stack, { spacing: 1, role: "status", sx: { py: 2 }, children: [_jsx(Typography, { variant: "subtitle1", component: "p", children: t(words.title, { reason: reasonText || t("monitoring.unavailable.unknownReason") }) }), _jsx(Typography, { variant: "body2", color: "text.secondary", children: t(words.help) }), problem || errors.length ? (_jsx(Box, { component: "ul", sx: { m: 0, pl: 3, typography: "body2" }, children: __spreadArray([problem], errors, true).filter(Boolean).map(function (message) { return (_jsx("li", { children: message }, message)); }) })) : null, state === EWidgetRenderState.RENDER_FAILED && table ? (_jsx(Fallback, { table: table, title: title })) : null] }));
}
